import React from 'react';
import { platformFeatures } from '../data/mock';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const PlatformFeaturesSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-16"
        >
          Everything You Need In One Holistic Platform
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {platformFeatures.map((feature, idx) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.15 }}
              className="group bg-[#f8faff] rounded-2xl p-8 hover:shadow-xl transition-shadow duration-300 border border-gray-100"
            >
              <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed mb-4">
                {feature.description}
              </p>
              <a
                href={feature.link}
                className="inline-flex items-center gap-1 text-sm font-semibold text-[#2563EB] hover:gap-2 transition-all"
              >
                Learn More <ArrowRight className="w-4 h-4" />
              </a>
              <div className="mt-6 overflow-hidden rounded-xl">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformFeaturesSection;
